import React from 'react';

const FadeChildComponents = (props) => {
  const { children } = props;

  return (
    <div {...props}>
      {children}
    </div>
  );
};

export default FadeChildComponents;